---
de:
  follow_up:
    achived_price: Erreichter Preis
    actual: Aktuell
    buy_production: Produktion kaufen
    cannibalism: Kanibalismus
    charts:
      capture_rates: Erfassungsraten
      captured_prices: Erfasste Preise
      consumption: Verbrauch
      cumulative_production: Kumulative Produktion
      cumulative_total_revenue: Kumulativer Gesamtumsatz
      full_load_factor: Volllastfaktor
      production: Produktion
      revenue: Umsatz
      revenues_phyiscal_financial: Einnahmen aus physischen und finanziellen Regelungen
      revenues_variable_fixed: Einnahmen aus variablen und festen Regelungen
      risk_and_cannibalism: Risiko und Kanibalismus
      spot_price: Spot-Preis
      volume: Volumen
    consumption: Verbrauch
    consumption_tab:
      paid: Bezahlt
      spot: Spot
    contracted: Vertraglich vereinbart
    financial: Finanziell
    fixed: Fest
    header: Leistungsbeurteilung
    hedge: Absicherung
    index: Index
    merchant: Händler
    merchant_base_value: Händler-Basiswert
    net: Nettowert
    overproduction: Überproduktion
    overview:
      actual: Aktuell
      expected: Erwartet
      full_load_factor: Volllastfaktor
      hedged_price: Absicherter Preis
      hedged_volume: Absichertes Volumen
      production: Produktion
    p50: p50
    physical: Physikalisch
    ref: Referenz
    revenues:
      contracted_sales_revenue: Vertraglich vereinbarter Verkaufsumsatz
      fixed_revenues: Feste Einnahmen
      physical_sales_revenue: Physischer Verkaufsumsatz
      variable_revenues: Variable Einnahmen
    risk:
      overproduction_risk: Überproduktionsrisiko
      production_shortfall: Produktionsmangelrisiko
    sell_production: Produktion verkaufen
    shared:
      captured: Erfasst
      revenue: Umsatz
      total: Gesamt
    shortfall: Mangel
    spot_price: Spot-Preis
    total: Gesamt
    variable: Variabel
    volume: Volumen
